import { render, staticRenderFns } from "./message-type-column.vue?vue&type=template&id=f3143198&scoped=true"
import script from "./message-type-column.vue?vue&type=script&lang=js"
export * from "./message-type-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3143198",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3143198')) {
      api.createRecord('f3143198', component.options)
    } else {
      api.reload('f3143198', component.options)
    }
    module.hot.accept("./message-type-column.vue?vue&type=template&id=f3143198&scoped=true", function () {
      api.rerender('f3143198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/reports/outbound-texts/messages/message-type-column.vue"
export default component.exports